import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {EmailSequence} from 'shells/sequence-progression/email-sequence-progression';

import type {
    GetLeadPrimaryContactDripSequenceProgressions as GetLeadPrimaryContactDripSequenceProgressionsQuery,
    GetLeadPrimaryContactDripSequenceProgressionsVariables as GetLeadPrimaryContactDripSequenceProgressionsQueryVariables,
} from 'nutshell-graphql-types';

import GET_LEAD_DRIP_SEQUENCE_PROGRESSIONS from '../../../deprecated/email-marketing/graphql/queries/get-lead-drip-sequence-progressions.graphql';

export const useGetLeadDripSequenceProgressions = (
    leadId: string
): {
    emailSequences: Array<EmailSequence>;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetLeadPrimaryContactDripSequenceProgressionsQuery,
        GetLeadPrimaryContactDripSequenceProgressionsQueryVariables
    >(GET_LEAD_DRIP_SEQUENCE_PROGRESSIONS, {
        variables: {leadId},
        notifyOnNetworkStatusChange: true,
    });

    // @ts-expect-error
    const emailSequences = [];
    if (data && data.lead && data.lead.contacts) {
        data.lead.contacts.edges.forEach((contact) =>
            contact.node.dripProgressions.forEach((sequence) => {
                if (sequence.nextEdition && sequence.nextEditionSendTime && sequence.campaign) {
                    emailSequences.push({
                        id: sequence.id,
                        name: sequence.campaign.name,
                        htmlUrlPath: sequence.campaign.htmlUrlPath,
                        length: sequence.campaign.editions.totalCount,
                        totalSent: sequence.numEditionsSent,
                        sendTime: sequence.nextEditionSendTime,
                        nextEdition: sequence.nextEdition
                            ? {
                                  name: sequence.nextEdition.name,
                                  emailTemplate: sequence.nextEdition.emailTemplate
                                      ? {
                                            id: sequence.nextEdition.emailTemplate.id,
                                        }
                                      : null,
                              }
                            : null,
                        entity: {
                            id: contact.node.id,
                            name: contact.node.name,
                            htmlUrl: contact.node.htmlUrl,
                        },
                        isPaused: Boolean(sequence.campaign.status === 'PAUSED'),
                    });
                }
            })
        );
    }

    return {
        // @ts-expect-error
        emailSequences,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
